import { defineNuxtPlugin } from 'nuxt/app'
import { messageDefaults } from 'element-plus'

/** Message 距顶部为视口高度的 40%（px），可被单次 ElMessage({ offset }) 覆盖 */
const MESSAGE_OFFSET_RATIO = 0.4

function getMessageOffset() {
  if (typeof window === 'undefined') return 0
  return Math.round(window.innerHeight * MESSAGE_OFFSET_RATIO)
}

export default defineNuxtPlugin(() => {
  Object.defineProperty(messageDefaults, 'offset', {
    get: () => getMessageOffset(),
    enumerable: true,
    configurable: true
  })
})
